import { render, staticRenderFns } from "./payRecord.vue?vue&type=template&id=d44a6284&scoped=true&"
import script from "./payRecord.vue?vue&type=script&lang=js&"
export * from "./payRecord.vue?vue&type=script&lang=js&"
import style0 from "./payRecord.vue?vue&type=style&index=0&id=d44a6284&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44a6284",
  null
  
)

export default component.exports